'use client'

import { useEffect, useState } from 'react'

export default function HeaderSpacer({
	minHeight = 'h-24',
	maxHeight = 'h-40',
}: {
	minHeight?: string
	maxHeight?: string
}) {
	const [showBanner, setShowBanner] = useState(false)

	useEffect(() => {
		const checkBanner = () => {
			const banner = document.getElementById('locale-banner')
			setShowBanner(!!banner)
		}

		// Check initially
		checkBanner()

		// Set up a MutationObserver to watch for changes to the DOM
		const observer = new MutationObserver(checkBanner)
		observer.observe(document.body, {
			childList: true,
			subtree: true,
		})

		// Listen for storage events (when banner is dismissed)
		const handleStorage = () => {
			checkBanner()
		}
		window.addEventListener('storage', handleStorage)

		// Cleanup
		return () => {
			observer.disconnect()
			window.removeEventListener('storage', handleStorage)
		}
	}, [])

	const height = showBanner ? maxHeight : minHeight

	return <div className={height} />
}
